import React from 'react';
import styled from 'styled-components';


const PrevIcon = () => {
  return (
      <>
          <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
              <g id="Arrow" transform="translate(0.707 0.707)">
                  <g id="Group_23756" data-name="Group 23756">
                      <line id="Line_3910" data-name="Line 3910" x1="5" y2="5" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                      <line id="Line_3911" data-name="Line 3911" x2="5" y2="5" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                  </g>
                  <line id="Line_3912" data-name="Line 3912" x1="10" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
              </g>
          </svg>

      </>
  );
};


export default React.memo(PrevIcon);
